import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { Images } from 'src/Tenants';
import "../ModernSidebar.scss";

interface SidebarFooterProps {
  collapseSideBar: boolean;
}

const SidebarFooter = ({ collapseSideBar }: SidebarFooterProps) => {
  const user = useSelector(selectAuthenticatedUser);

  return (
    <div
      className={classNames('sidebar-bottom', {
        'sidebar-bottom-collapsed': collapseSideBar,
      })}
    >
      <div className="sidebar-brand">
        <div className="sidebar-logo">
          <img alt="juniper" src={Images.logo} height="18" />
        </div>
        <div className="sidebar-customer">
          {user.tenant && user.tenant.name}
        </div>
      </div>
    </div>
  );
};

export default SidebarFooter;
